var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3054_20908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.25V5.25",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.25V5.25",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.25H20.25",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.125C12.4142 13.125 12.75 12.7892 12.75 12.375C12.75 11.9608 12.4142 11.625 12 11.625C11.5858 11.625 11.25 11.9608 11.25 12.375C11.25 12.7892 11.5858 13.125 12 13.125Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 13.125C16.5392 13.125 16.875 12.7892 16.875 12.375C16.875 11.9608 16.5392 11.625 16.125 11.625C15.7108 11.625 15.375 11.9608 15.375 12.375C15.375 12.7892 15.7108 13.125 16.125 13.125Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 16.875C8.28921 16.875 8.625 16.5392 8.625 16.125C8.625 15.7108 8.28921 15.375 7.875 15.375C7.46079 15.375 7.125 15.7108 7.125 16.125C7.125 16.5392 7.46079 16.875 7.875 16.875Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.875C12.4142 16.875 12.75 16.5392 12.75 16.125C12.75 15.7108 12.4142 15.375 12 15.375C11.5858 15.375 11.25 15.7108 11.25 16.125C11.25 16.5392 11.5858 16.875 12 16.875Z",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 16.875C16.5392 16.875 16.875 16.5392 16.875 16.125C16.875 15.7108 16.5392 15.375 16.125 15.375C15.7108 15.375 15.375 15.7108 15.375 16.125C15.375 16.5392 15.7108 16.875 16.125 16.875Z",
    fill: "#525252"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3054_20908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDots);
export default __webpack_public_path__ + "static/media/CalendarDots.926a8e88e9184e4c11314d8a69477ca6.svg";
export { ForwardRef as ReactComponent };